import React from "react";

const GreenTickIcon = ({ width, height, color }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7203 6.14801C14.3891 5.8701 13.8953 5.9133 13.6174 6.2445L8.58843 12.2378L6.29915 10.3169C5.97316 10.0434 5.48715 10.0859 5.21361 10.4119C4.94007 10.7379 4.98259 11.2239 5.30858 11.4974L8.17033 13.8987C8.31576 14.0207 8.49304 14.0799 8.6691 14.079C8.90949 14.0947 9.1539 13.9997 9.32063 13.801L14.8168 7.25091C15.0947 6.91971 15.0515 6.42592 14.7203 6.14801Z"
        fill="#39B67B"
      />
      <circle
        cx="10"
        cy="10.123"
        r="9.25"
        stroke="#39B67B"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default GreenTickIcon;
